export default {
      id: "angleDoubleRight-usage",
      viewBox: "0 0 14 14",
      url: "assets/" + "sprite.svg#angleDoubleRight-usage",
      toString: function () {
        return this.url;
      }
    }